var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tour-overlay",class:{ 'tour-overlay--active': _vm.active },style:({ backgroundColor: `rgba(0, 0, 0, ${_vm.opacity})` })},[(_vm.targetElement && _vm.active)?_c('div',{staticClass:"tour-highlight",style:(_vm.highlightStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }